import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { errorMonitoring } from './lib/utils/errorMonitoring';
import { analyticsService } from './lib/utils/analytics';
import App from './App.tsx';
import './index.css';

// Initialize services
errorMonitoring.initialize();
analyticsService.initialize();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
